
import { GetParamsData, PostDepositDefaultDate } from '$Deposits/lib/LibCommonData'
import { SetDepositNextStep, SetDepositSuccessPage, PostConfirmStep } from './DepositAction'
import { moneyReg } from '$Deposits/lib/Reg';
import { PayApiPort } from '../../Api'
import moment from 'moment'
import {
    GetMethodsActive,
    GetMethodCodeActive,
    GetMethodsDetails,
    GetDepositBankActive,
    GetDepositMemberBanksActive,
    GetUploadFileList,
    GetDepositMoneyStatus,
    GetDepositOldBankSixNumberStatus,
    GetDepositCardNumber_CC,
    GetDepositDateSelect,
    GetDepositTimeSelect,
    GetDepositCardPIN_CC,
    GetLBOfflineRefNo,
    GetMenber,
    GetDepositAccountByAmountValues
} from './DepositUpdate'

function toastErrMeaasge(data, flag) {
    const { toastTip } = GetParamsData() || {}
    let errors = data?.errors
    if (Array.isArray(errors) && errors.length) {
        let msg = errors[0]?.description?.includes('P10') ? (errors[0]?.message || 'Tiền gửi thất bại, xin vui lòng thử lại sau') : (errors[0]?.description || errors[0]?.message || 'Tiền gửi thất bại, xin vui lòng thử lại sau')
        if (flag) {
            return msg
        } else {
            toastTip.error(msg, 2)
        }
    }
}
//LB提交存款
export const SetDepositPayments_LB = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { accountNo = '', province = '', city = '', branch = '' } = GetDepositAccountByAmountValues() || GetDepositBankActive() || {}
        const { bankName, accountNumber, accountHolderName } = GetDepositMemberBanksActive() || {}
        const { methods } = GetMethodsActive()
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { transferTypes = [] } = GetMethodsDetails() || {}
        const { refNo } = GetLBOfflineRefNo() || {}
        const uploadFile = GetUploadFileList() || []
        const { fileName, fileBytes } = uploadFile[0] || {}
        const { isAutoAssign = false } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}
        const enBankName = isAutoAssign ? '' : GetDepositBankActive()?.enBankName

        // for localbank m3 please pass DepositingBankName and DepositingBankAccNum to the Payment/Application.
        // DepositingBankAccNum is from DepositAccountByAmount api response similar to M2.
        // DepositingBankName is from GetPaymentMethodDetail bff api
        toastTip.loading('Tiền gửi...', 50);
        let postData = {
            // 收款---
            depositingBankAcctNum: accountNo && accountNo.slice(-6) || '',

            // depositingBankName: enBankName || '',

            province: province || '',
            city: city || '',
            branch: branch || '',
            // 收款----

            // 付款---
            bankName: bankName || '',
            accountNumber: accountNumber || '',
            accountHolderName: accountHolderName || '',
            // 付款---
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: `${GetDepositDateSelect()} ${GetDepositTimeSelect() === 'NOT_SET' ? moment().format('HH:mm') : GetDepositTimeSelect()}`,
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: refNo ? refNo : '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: transferTypes[0] || '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            // bonusId: bonusId,
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: fileBytes || '',
            fileName: fileName || '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }
        if (!isAutoAssign && enBankName) {
            postData.depositingBankName = enBankName;
        }
        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }
        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    // dispatch(PostConfirmStep(res.result || {}))
                    if(fileBytes)
                        toastTip.success('Đăng Tải Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
export const SetDepositPayments_OldBank = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { bankName, accountNumber, accountHolderName } = GetDepositMemberBanksActive() || {}
        const { numCode } = GetDepositOldBankSixNumberStatus() || {}
        const { methods } = GetMethodsActive() || {}
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const uploadFile = GetUploadFileList() || []
        const { transferTypes = [] } = GetMethodsDetails() || {}
        const { fileName, fileBytes } = uploadFile[0] || {}
        toastTip.loading('Tiền gửi...', 50);
        let postData = {
            // 收款---
            depositingBankAcctNum: numCode || '',
            depositingBankName: '',
            province: '',
            city: '',
            branch: '',
            // 收款----

            // 付款---
            bankName: 'Ngân hàng khác',
            accountNumber: accountNumber || '',
            accountHolderName: accountHolderName || '',
            // 付款---
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: `${GetDepositDateSelect()} ${GetDepositTimeSelect()}`,
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: transferTypes[0] || '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            // bonusId: bonusId,
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: fileBytes || '',
            fileName: fileName || '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res, true);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    // dispatch(PostConfirmStep(res.result || {}))
                    if(fileBytes)
                        toastTip.success('Đăng Tải Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
export const SetDepositPayments_BQR = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { bankName, accountNo = '0', accountHolderName = '', enBankName = '' } = GetDepositBankActive() || {}
        const { methods } = GetMethodsActive() || {}
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { isAutoAssign } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, device, bonusRuleGroupId } = GetParamsData() || {}
        let firstName = GetMenber()?.firstName;
        toastTip.loading('Tiền gửi...', 50);
        let postData = {
            // 收款---
            depositingBankAcctNum: '',
            depositingBankName: '',
            province: '',
            city: '',
            branch: '',
            // 收款----
            // 付款---
            bankName: isAutoAssign ? 'nil' : bankName,
            accountNumber: '0', // P2 INCIDENT-56994
            accountHolderName: firstName,
            // 付款---
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: '',
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            // bonusId: bonusId,
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: '',
            fileName: '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (!isAutoAssign) {
            postData.depositingBankName = enBankName
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//FP存款
export const SetDepositPayments_FP = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}
        const { code } = GetDepositBankActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            bankName: code || '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: "Deposit",
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet, //目標帳戶
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}

//VP存款
export const SetDepositPayments_VP = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),

        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}

//MMO存款
export const SetDepositPayments_MMO = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: "Deposit",
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet, //目標帳戶
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//MMOLB存款
export const SetDepositPayments_MMLB = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { bankName, province, city, branch, enBankName, accountNo, accountHolderName } = GetDepositBankActive() || {}
        const { isAutoAssign } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            province: isAutoAssign ? '' : province,
            city: isAutoAssign ? '' : city,
            branch: isAutoAssign ? '' : branch,

            // 付款
            bankName: bankName,
            accountNumber: accountNo && accountNo.slice(-6) || '',
            accountHolderName: accountHolderName,
            depositingBankName: enBankName,

            domainName: domainName,
            // bonusId: bonusId,
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            isMobile: true,
            isSmallSet: false,
            refNo: '0',
            offlineDepositDate: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
            successUrl: successUrl,
            mgmtRefNo: mgmtRefNo,
            transfertype: '',
            offlineRefNo: '0',
            depositingWallet: depositingWallet,
            MethodCode: '',
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            iPAddress: '',
            currencyCode: currencyCode,
            Address: '',
            bankLogID: '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//CC卡存款
export const SetDepositPayments_CC = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { number } = GetDepositCardNumber_CC()
        const { PIN } = GetDepositCardPIN_CC()
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            cardNumber: number || '',
            cardPIN: PIN || '',
            refNo: number || '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//ZLP存款
export const SetDepositPayments_ZLP = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: "Deposit",
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet, //目標帳戶
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//LBQR存款
export const SetDepositPayments_LBQR = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { code } = GetDepositBankActive() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            bankName: '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//PHC存款
export const SetDepositPayments_PHC = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { code } = GetDepositBankActive() || {}
        const { methods } = GetMethodsActive() || {}
        const { charges } = GetMethodsDetails()['setting'] || {}
        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: charges,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            // bonusId: bonusId,
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            bankName: code || '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//QD存款
export const SetDepositPayments_QD = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { bankName, enBankName } = GetDepositBankActive() || {}
        const { accountHolderName, accountNumber } = GetDepositMemberBanksActive() || {}
        const { methods } = GetMethodsActive() || {}
        const { isAutoAssign } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}
        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            bankName: bankName,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            accountHolderName: accountHolderName,
            accountNumber: accountNumber,
            BankName: (GetDepositMemberBanksActive() || {}).bankName,
            amount: money,
            bankLogId: '',
            bonusCoupon: "",
            // bonusId: bonusId,
            charges: 0,
            depositingWallet: depositingWallet,
            domainName: domainName,
            fileBytes: "",
            fileName: "",
            isMobile: false,
            isSmallSet: false,
            language: language,
            mgmtRefNo: mgmtRefNo,
            offlineRefNo: "0",
            paymentMethod: methods,
            refNo: "0",
            successUrl: successUrl,
            transactionType: "Deposit",
            transferType: '',
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        if (!isAutoAssign) {
            postData.depositingBankName = enBankName
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}

export const SetDepositPayments_CTC = () => {

    return (dispatch, getState) => {
        const methodCode = GetMethodCodeActive() || {}
        if (methodCode == 'CHANNEL') {
            dispatch(SetDeposit_CHANNEL())
        } else {
            dispatch(SetDeposit_CTc())
        }

        const action = {
            type: 'UPLOAD_FILE_LIST_ss',
            data: [],
        };
        return dispatch(action);
    }


}
//CTC充值
export const SetDeposit_CTc = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, toastTip, ApiPost, depositingWallet, bonusRuleGroupId } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}
        toastTip.loading('Tiền gửi...', 50);
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            //bonusId: bonusId || '',
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        }

        if (bonusRuleGroupId) {
            postData.bonusRuleGroupId = bonusRuleGroupId
        } else {
            if (bonusId) {
                postData.bonusId = bonusId
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}
//虚拟币CHANNEL存款
export const SetDeposit_CHANNEL = (data = {}) => {
    const { code } = GetDepositBankActive() || {}
    const methodsCode = GetMethodCodeActive() || 'CHANNEL'
    const { toastTip, ApiGet } = GetParamsData() || {}

    return (dispatch, getState) => {
        toastTip.loading('Tiền gửi...', 50)
        return ApiGet(`${PayApiPort.CryptocurrencyDetails}coinsCurrency=${code}&methodCode=${methodsCode}&exchangeAmount=1&`)
            .then((res) => {
                toastTip.hide()
                sendPiwik(getState, res);
                let resData = res || {}
                if (resData.isSuccess) {
                    //toastTip.success('Sao Chép Thành Công', 2)
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastErrMeaasge(res)
                    //toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('Tiền gửi thất bại, xin vui lòng thử lại sau', 2)
                const action = { type: 'DEPOSIT_PAYMENTS', data: '' }
                return dispatch(action)
            })
    };
}


let DepostNamePiwik = {
    LB: 'Local Bank',
    QD: 'Express',
    LBQR: 'LBQR',
    FP: 'Fast Pay',
    MMO: 'MoMo Pay',
    ZLP: 'Zalo Pay',
    VP: 'Viettel Pay',
    PHC: 'Mobile Load',
    BQR: 'BQR',
    CC: 'Mobile Card',
    CTC: 'CTC'
}
const sendPiwik = (getState, res, isOld = false) => {
    const { device, webPiwikEvent, appPiwikEvent } = GetParamsData() || {}
    const { methods = '', name = '' } = GetMethodsActive() || {}
    const { DepositTriggerFrom = {} } = getState();
    const { from, vendor = {} } = DepositTriggerFrom;
    const { money } = GetDepositMoneyStatus()
    if (device === 'APP') {
        let vendorPiwikName = 'In' + vendor?.piwikName || ''
        let data = {
            category: from === "inGame" ? vendorPiwikName : 'Deposit',
            action: from === "inGame" ? `Submit Deposit ${methods}` : (isOld ? `Submit Deposit Old Bank` : `Submit Deposit ${name}`),
            name: from === "inGame" ? `${vendorPiwikName}_S_${methods}_Deposit` : (isOld ? 'Deposit_Old_Bank_S_Deposit' : `Deposit_${name}_S_Deposit`),
            path: from === "inGame" ? vendorPiwikName?.toLocaleLowerCase() : `deposit_${name.toLocaleLowerCase().replace(/\s/g, '_')}`,
            title: from === "inGame" ? vendorPiwikName : `${name} Deposit Page`,
            isSuccess: res.isSuccess ? 2 : 1,
        }
        if (res.isSuccess) {
            if (from === "inGame") {
                data.customProperties = {
                    [`${vendorPiwikName}_S_${methods}_Deposit_Amount`]: money
                }
            } else {
                data.customProperties = {
                    // [`Deposit_${isOld ? 'OldBank' : name}_S_Deposit_ErrorMsg`]: toastErrMeaasge(res, true),
                    [`Deposit_${isOld ? 'OldBank' : name}_S_Deposit_Amount`]: money
                }
            }
        }

        if (!res.isSuccess) {
            if (from === "inGame") {
                data.customProperties = {
                    [`${vendorPiwikName}_S_${isOld ? 'OldBank' : methods}_Deposit_ErrorMsg`]: toastErrMeaasge(res, true)
                }
            } else {
                data.customProperties = {
                    [`Deposit_${isOld ? 'OldBank' : name}_S_Deposit_ErrorMsg`]: toastErrMeaasge(res, true),
                }
            }
        }
        appPiwikEvent(data)
    } else {
        try {
            if (device === 'APP') { return }
            if (res.isSuccess) {
                global.fbqTag && fbqTag('rechargeClick')
            }
            if (!isOld) {
                webPiwikEvent(
                    vendor.piwikName ? `In${vendor.piwikName}` : `Deposit`,
                    `Submit Deposit ${DepostNamePiwik[methods]}`,
                    vendor.piwikName ? `In${vendor.piwikName}_S_${DepostNamePiwik[methods].replace(/\s+/g, '')}_Deposit` : `Deposit_${DepostNamePiwik[methods].replace(/\s+/g, '')}_S_Deposit`,
                    res.isSuccess ? "2" : "1",
                    [{
                        customVariableKey: res.isSuccess ? (from === 'deposit' ? `Deposit_${methods}_S_Deposit_Amount` : `In${vendor.piwikName}_S_${methods}_Deposit_Amount`) : (from === 'deposit' ? `Deposit_${methods}_S_Deposit_ErrorMsg` : `In${vendor.piwikName}_S_${methods}_Deposit_ErrorMsg`),
                        customVariableValue: res.isSuccess ? money : toastErrMeaasge(res, true)
                    }]
                )
            } else {
                webPiwikEvent(
                    from === 'deposit' ? `Deposit` : `In${vendor.piwikName}`,
                    `Submit Deposit ${methods}`,
                    from === 'deposit' ? `Deposit_Old_Bank_S_Deposit` : `In${vendor.piwikName}_S_Old_Bank_Deposit`,
                    res.isSuccess ? "2" : "1",
                    [{
                        customVariableKey: res.isSuccess ? (from === 'deposit' ? `Deposit_Old_Bank_S_Deposit_Amount` : `In${vendor.piwikName}_S_Old_Bank_Deposit_Amount`) : (from === 'deposit' ? `Deposit_Old_Bank_S_Deposit_ErrorMsg` : `In${vendor.piwikName}_S_Old_Bank_Deposit_ErrorMsg`),
                        customVariableValue: res.isSuccess ? money : toastErrMeaasge(res, true)
                    }]
                )
            }


        } catch (e) {
            console.log('Error occurred in DepositPost.sendPiwik ', e)
        }
    }
}
